import { IReview, TProduct, TReviews, TSet, TSetAmmounts } from "../constants/types";
import { IsNull } from "./Globals";

export function Init(getAvailable: boolean=true, isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }
    return fetch(`${hostUrl}/Init?getAvailable=${getAvailable}`, {
        method: 'GET',
    }).then((response) => {
        return response.json();
    }).then((data) => {
        return data;
    });
}

export function GetProductsCountAll(isDev : boolean = false, minlimit : number = 0) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }

    return fetch(`${hostUrl}/CardsCountAll?minlimit=${minlimit}`, {
        method: 'GET',
    }).then((response) => response.json()).then((data) => data as TSetAmmounts[]);
}

export function GetConfiguration(isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }
    return fetch(`${hostUrl}/GetConfiguration`, {
        method: 'GET',
    }).then((response) => response.json()).then((data) => data);
}

export function GetConnect(isMobile: boolean, isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }
    return fetch(`${hostUrl}/GetConnect?isMobile=${isMobile}`, {
        method: 'GET',
    });
}

export function  GetSets(isDev : boolean = false, onlyAvailable : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }
    return fetch(`${hostUrl}/sets?onlyAvailable=${onlyAvailable}`, {
        method: 'GET',
    }).then((response) => response.json()).then((data) => data as TSet[]);
}

export function GetFiatPrices(isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }
    return fetch(`${hostUrl}/FiatPrices`, {
        method: 'GET',
        mode: 'cors',
    }).then((response) => response.json()).then((data) => data as number[] );
}

export function GetBTCPrice(isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }
    return fetch(`${hostUrl}/BTCPrice`, {
        method: 'GET',
        mode: 'cors',
    }).then((response) => response.json()).then((data) => data as number );
}

export function GetEURPrice(isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }
    return fetch(`${hostUrl}/EURPrice`, {
        method: 'GET',
        mode: 'cors',
    }).then((response) => response.json()).then((data) => data as number );
}

export function GetUSDPrice(isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }
    return fetch(`${hostUrl}/USDPrice`, {
        method: 'GET',
        mode: 'cors',
    }).then((response) => response.json()).then((data) => data as number );
}

// export function GetReviews(isDev: boolean = false) {
//     let hostUrl = `${window.location.origin}/Backend`
//     if (isDev) {
//         hostUrl = process.env.REACT_APP_DEV_API_URL;
//     }

//     return fetch(`${hostUrl}/GetReviews`, {
//         method: 'GET',
//     }).then((response) => response.json()).then((data) => data as TReviews );
// }

export function ProductAllUpdates(isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }

    return fetch(`${hostUrl}/ProductUpdates`, {
        method: 'GET',
    }).then((response) => response.json()).then((data) => data as TProduct[] );
}

export function ProductUpdates(setname:string, isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }

    return fetch(`${hostUrl}/ProductUpdates?setname=${encodeURIComponent(setname)}`, {
        method: 'GET',
    }).then((response) => response.json()).then((data) => data as TProduct[] );
}

export function SearchProducts(searchTerm:string, getAvailableOnly:boolean, isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }

    return fetch(`${hostUrl}/SearchProducts?getAvailable=${!getAvailableOnly}${IsNull(searchTerm) ? "" : "&searchTerm="+encodeURIComponent(searchTerm)}`, {
        method: 'GET',
    }).then((response) => response.json()).then((data) => data as TProduct[] );
}

export function GetProduct(productid:number | string, isDev:boolean=false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }

    return fetch(`${hostUrl}/card?id=${productid}`, {
        method: 'GET',
    }).then((response) => response.json()).then((data) => data as TProduct[] );
}

export function GetProducts(setname:string | number, getAvailableOnly:boolean, isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }

    return fetch(`${hostUrl}/cards?setname=${encodeURIComponent(setname)}&getAvailable=${!getAvailableOnly}`, {
        method: 'GET',
    }).then((response) => response.json()).then((data) => data as TProduct[] );
}

export function GetSetProductCount(setname:string, isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }

    return fetch(`${hostUrl}/ProductsCount?setname=${encodeURIComponent(setname)}`, {
        method: 'GET',
    }).then((response) => response.json()).then((data) => data as number );
}

export function SetAlert(productID:number, setID:number, setName:string, email:string, isDev : boolean = false) {
    let hostUrl = `${window.location.origin}/Backend`
    if (isDev) {
        hostUrl = process.env.REACT_APP_DEV_API_URL;
    }
    //(int productID, int setID, string setName, string email)
    return fetch(`${hostUrl}/SetProductAlert?productID=${productID}&setID=${setID}&setName=${setName}&email=${email}`, {
        method: 'GET',
    }).then((response) => {return true;}).catch(err => {
        return false;
    });
}